import React, { useRef, useState } from 'react';
import { galleryImages } from '../mockData';

export const Gallery = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const index = Math.round(el.scrollLeft / el.clientWidth);
    setActiveIndex(index);
  };

  const scrollToIndex = (index) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
  };

  return (
    <section id="gallery" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-blue-50" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">Our Work</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See our professional team in action. We take pride in every move we complete.
          </p>
        </div>

        {/* Desktop / Tablet Grid */}
        <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-6" data-testid="gallery-grid">
          {galleryImages.map((image, idx) => (
            <div
              key={idx}
              className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer aspect-[4/3]"
              data-testid={`gallery-item-${idx}`}
            >
              <img
                src={image}
                alt={`MoveMate Sydney Removals moving service ${idx + 1} - professional removalists`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A5F]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="sm:hidden" data-testid="gallery-carousel">
          <div
            ref={scrollRef}
            onScroll={handleScroll}
            className="flex overflow-x-auto snap-x snap-mandatory scroll-smooth gap-4 -mx-4 px-4 pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
          >
            {galleryImages.map((image, idx) => (
              <div
                key={idx}
                className="relative shrink-0 basis-full snap-center overflow-hidden rounded-xl shadow-lg aspect-[4/3]"
                data-testid={`gallery-slide-${idx}`}
              >
                <img
                  src={image}
                  alt={`MoveMate Sydney Removals moving service ${idx + 1} - professional removalists`}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A5F]/40 to-transparent" />
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5" data-testid="gallery-dots">
            {galleryImages.map((_, idx) => (
              <button
                key={idx}
                onClick={() => scrollToIndex(idx)}
                aria-label={`Go to slide ${idx + 1}`}
                data-testid={`gallery-dot-${idx}`}
                className={`h-2.5 rounded-full transition-all duration-300 ${
                  activeIndex === idx ? 'w-7 bg-[#1E3A5F]' : 'w-2.5 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
